// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_classificacao{
    
  min-height: calc(100% - 3em);
  margin: 1.5em;
}

.caixa_classificacao h1 {
  font-weight: bold;
  color: var(--cor-pretoForte);
  font-family: "Roboto";
  font-size: 22px;
  margin-bottom: 20px;
  margin-left: 9px;
}

.caixa_classificacao h2 {
  font-weight: normal;
  font-family: "Roboto";
  font-size: 22px;
  margin-left: 9px;
}

.caixa_tabela {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/paginas/aluno/Ranking.css"],"names":[],"mappings":"AAAA;;EAEE,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".container_classificacao{\n    \n  min-height: calc(100% - 3em);\n  margin: 1.5em;\n}\n\n.caixa_classificacao h1 {\n  font-weight: bold;\n  color: var(--cor-pretoForte);\n  font-family: \"Roboto\";\n  font-size: 22px;\n  margin-bottom: 20px;\n  margin-left: 9px;\n}\n\n.caixa_classificacao h2 {\n  font-weight: normal;\n  font-family: \"Roboto\";\n  font-size: 22px;\n  margin-left: 9px;\n}\n\n.caixa_tabela {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
